import React, { memo, Fragment, useEffect, useCallback } from 'react';
import { TabsBlockForm, TabsForm } from './TabsBlock';
import { Row, Col, Label } from 'reactstrap';
import { useObservable } from '@core/utils/hooks/rxjs';
import { SortableElement, SortableHandle, SortEnd } from 'react-sortable-hoc';
import { R } from '@core/utils/r';
import { SortableList } from '@modules/common/Sortable';
import { FormHTMLInline, FormInput } from '@core/components/form';

export interface TabsBlockSettingsProps {
  form: TabsBlockForm;
}

export const TabsBlockSettings = memo((props: TabsBlockSettingsProps) => {
  const { form } = props;
  const tabs = useObservable(form.controls.tabs.items$, []);
  const tabValues = useObservable(form.controls.tabs.value$, []);

  // useEffect(() => {
  //   if (tabs.length === 0) {
  //     form.controls.tabs.push();
  //   }
  // }, [form, tabs]);

  const onSortEnd = useCallback(
    (sort: SortEnd) => {
      const oldIndex = sort.oldIndex;
      const newIndex = sort.newIndex;
      const newTabs = R.move(tabValues, oldIndex, newIndex);
      form.patchValue({
        tabs: newTabs,
      });
    },
    [form, tabValues],
  );

  return (

    <Fragment>
      {/* {!!tabs.length && <Label>Tabs</Label>}
      <SortableList lockAxis="y" distance={2} onSortEnd={sort => onSortEnd(sort)} useDragHandle={true} helperClass="z5000">
        {tabs.map((ctrl, index) => {
          return <SortableTabItem key={index} index={index} ctrl={ctrl} form={form} i={index} />;
        })}
      </SortableList> */}
    </Fragment>
  );
});

interface TabItemProps {
  i: number;
  ctrl: TabsForm;
  form: TabsBlockForm;
}

const TabItem = memo((props: TabItemProps) => {
  const { ctrl, form, i } = props;

  const DragHandle = SortableHandle(() => <i className="fas fa-grip-vertical" style={{ cursor: 'move' }}></i>);

  return (
    <div>
      <label className='text-muted' style={{ opacity: .5 }}>Tab #{i + 1}</label>
      <Row key={`tab-${i} mb-2 mt-2`}>
        <Col md={1}>
          <DragHandle />
        </Col>
        <Col md={8}>
          <FormInput control={ctrl.controls.tab} />
          <FormInput control={ctrl.controls.paragraph} type="textarea" />
        </Col>
        <Col md={2}>
          {!i && (
            <a className="btn btn-outline-primary btn-sm mr-2" onClick={() => form.controls.tabs.push()}>
              Add Tab
            </a>
          )}
          {!!i && (
            <a className="btn btn-outline-danger btn-sm mr-2" onClick={() => form.controls.tabs.removeAt(i)}>
              <i className="bx bx-x"></i>
            </a>
          )}
        </Col>
      </Row>
      <hr />
    </div>
  );
});

export const SortableTabItem = SortableElement(TabItem);